import { render } from "./CallActivity.vue?vue&type=template&id=94a73de6&scoped=true"
import script from "./CallActivity.vue?vue&type=script&lang=js"
export * from "./CallActivity.vue?vue&type=script&lang=js"

import "./CallActivity.vue?vue&type=style&index=0&id=94a73de6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94a73de6"]])

export default __exports__